import { useContext } from 'react';
import { StatusFilterContext } from '../providers/StatusFilterProvider';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => useContext(StatusFilterContext);